import type { PropsWithChildren, ReactNode } from 'react'

type SplitAuthLayoutProps = PropsWithChildren<{
  hero?: ReactNode
  mode?: 'split' | 'centered' | 'wide'
}>

export function SplitAuthLayout({
  children,
  hero,
  mode = 'split',
}: SplitAuthLayoutProps) {
  const modeGridClasses = {
    split: 'lg:grid-cols-[minmax(0,66fr)_minmax(0,34fr)]',
    centered: 'lg:grid-cols-[minmax(0,var(--layout-panel-width))]',
    wide: 'lg:grid-cols-[minmax(0,72rem)]',
  }

  const layoutClassName = [
    'mx-auto grid min-h-32 w-full max-w-[var(--layout-content-max)] items-stretch justify-center gap-0',
    'px-4 py-[var(--layout-page-padding-block)]',
    'h-[100svh] grid-cols-1 justify-items-center',
    'md:px-6 lg:justify-items-stretch lg:px-[var(--layout-page-padding-inline)]',
    modeGridClasses[mode],
  ]
    .filter(Boolean)
    .join(' ')

  const mediaClassName =
    'hidden min-w-0 items-center justify-center lg:flex'

  const panelMarginClass = {
    split: 'max-w-[var(--layout-panel-width)] lg:ml-[calc(var(--layout-auth-panel-shift)*-1)]',
    centered: 'max-w-[var(--layout-panel-width)] lg:ml-0',
    wide: 'max-w-[72rem] lg:ml-0',
  }

  const panelClassName = [
    'relative z-[1] min-w-0 w-full self-center lg:mx-0',
    panelMarginClass[mode],
  ].join(' ')

  return (
    <section className={layoutClassName}>
      {hero ? <div className={mediaClassName}>{hero}</div> : null}
      <div className={panelClassName}>{children}</div>
    </section>
  )
}
